import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'

export const mapStore = persistentInit<{
  bounds: google.maps.LatLngBoundsLiteral | undefined
  center: google.maps.LatLngLiteral | undefined
  zoom: number
  currentLocation: google.maps.LatLngLiteral | null
}>({
  initialState: {
    bounds: undefined,
    center: undefined,
    zoom: 14,
    currentLocation: null,
  },
  keysToPutInPersistentStorage: {
    bounds: true,
    center: true,
    zoom: true,
    currentLocation: false,
  },
  keysToPutInURL: {
    bounds: true,
    center: true,
    zoom: true,
    currentLocation: false,
  },
  storeName: PersistentStoreName.MAP_STORE,
})
